// eslint-disable-next-line
import {
  UserLayout,
  BasicLayout,
  RouteView,
  // BlankLayout,
  PageView
} from "@/layouts";
export const asyncRouterMap = [
  {
    path: "/",
    name: "index",
    component: BasicLayout,
    meta: {
      title: "首页"
    },
    redirect: "/dashboard/workplace",
    children: [
      {
        path: "dashboard/workplace",
        name: "dashboard",
        component: () => import("@/views/dashboard/Workplace"),
        meta: {
          title: "主页", // 标题
          keepAlive: true, // 是否保持状态(生机)多页签时
          icon: "home", //图标
          permission: ["dashboard"] //权限
        }
      },
      {
        path: "house",
        name: "house",
        component: RouteView,
        redirect: "/house/houseList",
        meta: {
          title: "房源管理", // 标题
          keepAlive: true, // 是否保持状态(生机)多页签时
          icon: "table", //图标
          permission: ["dashboard"] //权限
        },
        children: [
          {
            path: "houseList",
            name: "HouseList",
            component: () => import("@/views/room/house/HouseList"),
            meta: {
              title: "房源列表",
              keepAlive: false,
              permission: ["dashboard"]
            }
          },
          {
            path: "/house/houseList/addHouse",
            name: "AddHouse",
            hidden: true,
            component: () => import("@/views/room/house/AddHouse"),
            meta: {
              title: "添加房源",
              lateralSubpage: true, //是否是平级子页面
              keepAlive: false,
              permission: ["dashboard"]
            }
          },
          {
            path: "/house/houseList/modifyHouse",
            name: "ModifyHouse",
            hidden: true,
            component: () => import("@/views/room/house/ModifyHouse"),
            meta: {
              title: "编辑房源",
              lateralSubpage: true, //是否是平级子页面
              keepAlive: false,
              permission: ["dashboard"]
            }
          },
          {
            path: "/house/houseList/houseInfo",
            name: "HouseInfo",
            hidden: true,
            component: () => import("@/views/room/house/HouseInfo"),
            meta: {
              title: "房源信息",
              lateralSubpage: true, //是否是平级子页面
              keepAlive: false,
              permission: ["dashboard"]
            }
          },
          {
            path: "/house/houseList/createLease",
            name: "CreateLeaseInfo",
            hidden: true,
            component: () => import("@/views/room/house/CreateLeaseInfo"),
            meta: {
              title: "创建租约",
              lateralSubpage: true, //是否是平级子页面
              keepAlive: false,
              permission: ["dashboard"]
            }
          },
          {
            path: "/house/star/StarList",
            name: "StarList",
            // hidden: false,
            component: () => import("@/views/room/star/StarList"),
            meta: {
              title: "房源收藏",
              // lateralSubpage: true, //是否是平级子页面
              keepAlive: false,
              permission: ["dashboard"]
            }
          },
          {
            path: "houseMap",
            name: "HouseMap",
            component: () => import("@/views/room/house/HouseMap"),
            meta: {
              title: "房源地图",
              keepAlive: true,
              permission: ["dashboard"]
            }
          }
        ]
      },
      // account账户
      {
        path: "/account",
        component: RouteView,
        redirect: "/account/settings",
        name: "account",
        hidden: true,
        meta: {
          title: "个人页",
          icon: "user",
          keepAlive: true
          // permission: ['dashboard']
        },
        children: [
          {
            path: "/account/settings",
            name: "settings",
            component: () => import("@/views/room/account/settings/Index"),
            meta: {
              title: "个人设置",
              hideHeader: true
              // permission: ['dashboard']
            },
            redirect: "/account/settings/base",
            hideChildrenInMenu: true,
            children: [
              {
                path: "/account/settings/base",
                name: "BaseSettings",
                component: () =>
                  import("@/views/room/account/settings/BaseSetting"),
                meta: {
                  title: "基本设置",
                  hidden: true
                }
              },
              {
                path: "/account/settings/security",
                name: "SecuritySettings",
                component: () =>
                  import("@/views/room/account/settings/Security"),
                meta: {
                  title: "安全设置",
                  hidden: true,
                  keepAlive: true
                }
              },
              {
                path: "/account/settings/merchant",
                name: "MerchantInfo",
                component: () =>
                  import("@/views/room/account/settings/MerchantInfo"),
                meta: {
                  title: "商户信息",
                  hidden: true,
                  keepAlive: true
                }
              },
              {
                path: "/account/settings/merchantAccount",
                name: "MerchantAccount",
                component: () =>
                  import("@/views/room/account/settings/MerchantAccount"),
                meta: {
                  title: "商户收款账户",
                  hidden: true,
                  keepAlive: true
                }
              },
              {
                path: "/account/settings/merchantSignAuthFile",
                name: "MerchantSignAuthFile",
                component: () =>
                  import("@/views/room/account/settings/MerchantSignAuthFile"),
                meta: {
                  title: "自动签授权文件",
                  hidden: true,
                  keepAlive: true
                }
              }
            ]
          }
        ]
      },
      {
        path: "/keeper",
        component: RouteView,
        name: "keeper",
        // hidden: true,
        redirect: "/keeper/keeperList",
        meta: {
          title: "管家",
          icon: "usergroup-add",
          keepAlive: true
        },
        children: [
          {
            path: "/keeper/keeperList",
            name: "KeeperList",
            component: () => import("@/views/room/keeper/KeeperList"),
            meta: {
              title: "管家列表",
              hideHeader: true
            }
          }
        ]
      },
      {
        path: "/lease",
        component: RouteView,
        name: "lease",
        redirect: "/lease/leaseList",
        meta: {
          title: "签约",
          icon: "solution",
          keepAlive: true
        },
        children: [
          {
            path: "/lease/leaseList",
            name: "LeaseList",
            component: () => import("@/views/room/lease/LeaseList"),
            meta: {
              title: "租约管理",
              hideHeader: true
            }
          },
          {
            path: "/lease/leaseRentList",
            name: "LeaseRentList",
            component: () => import("@/views/room/lease/LeaseRentList"),
            meta: {
              title: "交租管理",
              hideHeader: true
            }
          },
          {
            path: "/lease/template",
            name: "ContractTemplateList",
            component: () => import("@/views/room/lease/TemplateList"),
            meta: {
              title: "合同模板",
              hideHeader: true,
              permission: ["contract_template"]
            }
          },
          {
            path: "/contract/order",
            name: "ContractOrderList",
            component: () => import("@/views/room/order/ContractOrderList"),
            meta: {
              title: "合同订单",
              hideHeader: true
            }
          },
          {
            path: "/contract/order/add",
            name: "AddContractOrder",
            hidden: true,
            component: () => import("@/views/room/order/AddContractOrder"),
            meta: {
              title: "购买合同",
              lateralSubpage: true, //是否是平级子页面
              keepAlive: false
            }
          },
          {
            path: "/contract/record",
            name: "ContractList",
            component: () => import("@/views/room/record/ContractList"),
            meta: {
              title: "合同记录",
              hideHeader: true
            }
          }
        ]
      },
      {
        path: "/make",
        component: RouteView,
        name: "make",
        redirect: "/make/makeList",
        meta: {
          title: "预约",
          icon: "phone",
          keepAlive: true
        },
        children: [
          {
            path: "/make/makeList",
            name: "MakeList",
            component: () => import("@/views/room/make/MakeList"),
            meta: {
              title: "预约管理",
              hideHeader: true
            }
          }
        ]
      }
    ]
  },
  {
    path: "*",
    redirect: "/404",
    hidden: true
  }
];
//系统用户路由
export const asyncSystemRouterMap = [
  {
    path: "/",
    name: "index",
    component: BasicLayout,
    meta: {
      title: "首页"
    },
    redirect: "/dashboard/control",
    children: [
      //一级菜单
      {
        path: "dashboard/control",
        name: "dashboard",
        component: () => import("@/views/dashboard/ControlCenter"),
        meta: {
          title: "Control Center", // 标题
          keepAlive: true, // 是否保持状态(生机)多页签时
          icon: "home", //图标
          permission: ["control"] //权限
        }
      },
      {
        path: "system",
        name: "system",
        component: RouteView,
        redirect: "/system/admin", //如果地址输入system，则自动跳转到systemAdmin
        meta: {
          title: "系统管理", // 标题
          keepAlive: true, // 是否保持状态(生机)多页签时
          icon: "table", //图标
          permission: ["system"] //权限
        },
        children: [
          //二级菜单
          {
            path: "admin",
            name: "systemAdmin",
            component: () => import("@/views/system/admin/AdminList"),
            meta: {
              title: "系统用户",
              keepAlive: false,
              permission: ["admin"]
            }
          },
          {
            path: "permission",
            name: "systemPermission",
            component: () => import("@/views/system/permission/PermissionList"),
            meta: {
              title: "系统资源",
              keepAlive: false,
              permission: ["permission"]
            }
          },
          {
            path: "role",
            name: "systemRole",
            component: () => import("@/views/system/role/RoleList"),
            meta: {
              title: "系统角色",
              keepAlive: false,
              permission: ["role"]
            }
          },
          {
            path: "province",
            name: "ProvinceList",
            component: () => import("@/views/system/province/ProvinceList"),
            meta: {
              title: "省份管理",
              keepAlive: false,
              permission: ["province"]
            }
          },
          {
            path: "city",
            name: "CityList",
            component: () => import("@/views/system/city/CityList"),
            meta: {
              title: "城市管理",
              keepAlive: false,
              permission: ["city"]
            }
          },
          {
            path: "district",
            name: "DistrictList",
            component: () => import("@/views/system/district/DistrictList"),
            meta: {
              title: "区域管理",
              keepAlive: false,
              permission: ["district"]
            }
          },
          {
            path: "circle",
            name: "CircleList",
            component: () => import("@/views/system/circle/CircleList"),
            meta: {
              title: "商圈管理",
              keepAlive: false,
              permission: ["circle"]
            }
          },
          {
            path: "dict",
            name: "DictList",
            component: () => import("@/views/system/dict/DictList"),
            meta: {
              title: "字典管理",
              keepAlive: false,
              permission: ["dict"]
            }
          }
        ]
      },
      {
        path: "general",
        name: "general",
        component: RouteView,
        redirect: "/general/user",
        meta: {
          title: "用户管理", // 标题
          keepAlive: true, // 是否保持状态(生机)多页签时
          icon: "table", //图标
          permission: ["general"] //权限
        },
        children: [
          //二级菜单
          {
            path: "user",
            name: "UserList",
            component: () => import("@/views/system/user/UserList"),
            meta: {
              title: "普通用户",
              keepAlive: false,
              permission: ["user"]
            }
          },
          {
            path: "/general/user/info",
            name: "UserInfo",
            hidden: true,
            component: () => import("@/views/system/user/UserInfo"),
            meta: {
              title: "用户信息",
              lateralSubpage: true, //是否是平级子页面
              keepAlive: false
            }
          }
        ]
      },
      {
        path: "product",
        name: "product",
        component: RouteView,
        redirect: "/product/contract",
        meta: {
          title: "产品管理", // 标题
          keepAlive: true, // 是否保持状态(生机)多页签时
          icon: "table", //图标
          permission: ["product"] //权限
        },
        children: [
          //二级菜单
          {
            path: "contract",
            name: "ContractGoodsList",
            component: () => import("@/views/system/product/ContractGoodsList"),
            meta: {
              title: "合同配置",
              keepAlive: false,
              permission: ["contract"]
            }
          },
          {
            path: "/product/contract/info",
            name: "ContractGoodsInfo",
            hidden: true,
            component: () => import("@/views/system/product/ContractGoodsInfo"),
            meta: {
              title: "配置信息",
              lateralSubpage: true, //是否是平级子页面
              keepAlive: false
            }
          }
        ]
      },
      {
        path: "merchant",
        name: "merchant",
        component: RouteView,
        redirect: "/merchant/information", //如果地址输入system，则自动跳转到systemAdmin
        meta: {
          title: "商户管理", // 标题
          keepAlive: true, // 是否保持状态(生机)多页签时
          icon: "shop", //图标
          permission: ["merchant"] //权限
        },
        children: [
          {
            path: "information",
            name: "MerchantList",
            component: () => import("@/views/system/merchant/MerchantList"),
            meta: {
              title: "商户信息",
              keepAlive: false,
              permission: ["information"]
            }
          },
          {
            path: "information/merchantInfo",
            name: "MerchantInfo",
            hidden: true,
            component: () => import("@/views/system/merchant/MerchantInfo"),
            meta: {
              title: "查看商户信息",
              lateralSubpage: true, //是否是平级子页面
              keepAlive: false,
              permission: ["information"]
            }
          },
          {
            path: "information/modify",
            name: "ModifyMerchantInfo",
            hidden: true,
            component: () =>
              import("@/views/system/merchant/ModifyMerchantInfo"),
            meta: {
              title: "编辑商户信息",
              lateralSubpage: true, //是否是平级子页面
              keepAlive: false,
              permission: ["information"]
            }
          },
          {
            path: "contractTemplate",
            name: "ContractTemplateList",
            component: () =>
              import("@/views/system/merchant/ContractTemplateList"),
            meta: {
              title: "合同模板管理",
              keepAlive: false,
              permission: ["contracttemplate"]
            }
          }
        ]
      },
      {
        path: "housing",
        name: "housing",
        component: RouteView,
        redirect: "/housing/community", //如果地址输入system，则自动跳转到systemAdmin
        meta: {
          title: "房源管理", // 标题
          keepAlive: true, // 是否保持状态(生机)多页签时
          icon: "database", //图标
          permission: ["housing"] //权限
        },
        children: [
          {
            path: "community",
            name: "CommunityList",
            component: () => import("@/views/system/housing/CommunityList"),
            meta: {
              title: "小区信息",
              keepAlive: false,
              permission: ["community"]
            }
          },
          {
            path: "house",
            name: "HouseList",
            component: () => import("@/views/system/housing/HouseList"),
            meta: {
              title: "房源信息",
              keepAlive: false,
              permission: ["houseinfo"]
            }
          },
          {
            path: "houseInfo",
            name: "HouseInfo",
            hidden: true,
            component: () => import("@/views/room/house/HouseInfo"),
            meta: {
              title: "房源信息",
              lateralSubpage: true, //是否是平级子页面
              keepAlive: false,
              permission: ["houseinfo"]
            }
          }
        ]
      },
      {
        path: "/feedback",
        component: RouteView,
        name: "feedback",
        redirect: "/feedback/feedbackList",
        meta: {
          title: "投诉/建议",
          icon: "read",
          keepAlive: true,
          permission: ["advcom"] //权限
        },
        children: [
          {
            path: "/feedback/feedbackList",
            name: "FeedbackList",
            component: () => import("@/views/system/feedback/FeedbackList"),
            meta: {
              title: "投诉建议管理",
              hideHeader: true,
              permission: ["advicecomplaint"] //权限
            }
          }
        ]
      },
      {
        path: "audit", //审计(设置，投诉等管理)
        name: "audit",
        component: RouteView,
        redirect: "/audit/options", //如果地址输入system，则自动跳转到systemAdmin
        meta: {
          title: "设置管理", // 标题
          keepAlive: true, // 是否保持状态(生机)多页签时
          icon: "audit", //图标
          permission: ["audit"] //权限
        },
        children: [
          {
            path: "options",
            name: "OptionList",
            component: () => import("@/views/system/option/OptionList"),
            meta: {
              title: "系统参数管理",
              keepAlive: false,
              permission: ["options"]
            }
          },
          {
            path: "thirdConfig",
            name: "ThirdConfigList",
            component: () =>
              import("@/views/system/thirdconfig/ThirdConfigList"),
            meta: {
              title: "第三方应用配置",
              keepAlive: false,
              permission: ["thirdconfig"]
            }
          },
          {
            path: "edmTemplate",
            name: "TemplateList",
            component: () => import("@/views/system/template/TemplateList"),
            meta: {
              title: "消息模板管理",
              keepAlive: false,
              permission: ["edmtemplate"]
            }
          },
          {
            path: "edmVerify",
            name: "EdmVerifyList",
            component: () => import("@/views/system/audit/EdmVerifyList"),
            meta: {
              title: "验证码管理",
              keepAlive: false,
              permission: ["edmverify"]
            }
          },
          {
            path: "sendSms",
            name: "SendSmsList",
            component: () => import("@/views/system/sendsms/SendSmsList"),
            meta: {
              title: "短信发送记录",
              keepAlive: false,
              permission: ["sendsms"]
            }
          },
          {
            path: "sendEmail",
            name: "SendEmailList",
            component: () => import("@/views/system/sendemail/SendEmailList"),
            meta: {
              title: "邮件发送记录",
              keepAlive: false,
              permission: ["sendemail"]
            }
          },
          {
            path: "appVersion",
            name: "AppVersionList",
            component: () => import("@/views/system/audit/AppVersionList"),
            meta: {
              title: "系统版本管理",
              keepAlive: false,
              permission: ["appversion"]
            }
          },
          {
            path: "systemService",
            name: "SystemServiceList",
            component: () => import("@/views/system/api/SystemServiceList"),
            meta: {
              title: "系统API管理",
              keepAlive: false,
              permission: ["service"]
            }
          },
          {
            path: "/audit/systemService/api",
            name: "SystemServiceApiList",
            hidden: true,
            component: () => import("@/views/system/api/SystemServiceApiList"),
            meta: {
              title: "API列表",
              lateralSubpage: true, //是否是平级子页面
              keepAlive: false,
              permission: ["service"]
            }
          }
        ]
      },
      {
        path: "/adminAccount",
        component: RouteView,
        redirect: "/adminAccount/settings",
        name: "adminAccount",
        hidden: true, //菜单隐藏以及该菜单下的所有子菜单
        meta: {
          title: "个人页",
          icon: "user",
          keepAlive: true
        },
        children: [
          {
            path: "settings",
            name: "settings",
            component: () => import("@/views/system/admin/settings/Index"),
            meta: {
              title: "个人设置"
            },
            redirect: "/adminAccount/settings/base",
            hideChildrenInMenu: true,
            children: [
              {
                path: "base",
                name: "AdminBaseSetting",
                component: () =>
                  import("@/views/system/admin/settings/AdminBaseSetting"),
                meta: {
                  title: "基本设置"
                  // hidden: true
                }
              },
              {
                path: "security",
                name: "AdminSecurity",
                component: () =>
                  import("@/views/system/admin/settings/AdminSecurity"),
                meta: {
                  title: "安全设置"
                  // hidden: true
                }
              }
            ]
          }
        ]
      }
    ]
  },
  {
    path: "*",
    redirect: "/404",
    hidden: true
  }
];
//默认路由
export const constantRouterMap = [
  {
    path: "/user",
    component: UserLayout,
    name: "user",
    redirect: "/user/login",
    hidden: true,
    children: [
      {
        path: "login",
        name: "login",
        meta: {
          title: "登录"
        },
        component: () => import("@/views/user/Login")
      }
    ]
  },
  {
    path: "/admin",
    name: "admin",
    component: UserLayout,
    redirect: "/admin/adminLogin",
    hidden: true,
    children: [
      {
        path: "adminLogin",
        name: "adminLogin",
        meta: {
          title: "登录"
        },
        component: () => import("@/views/user/AdminLogin")
      }
    ]
  },
  // {
  //   path: "/home",
  //   name: "Home",
  //   component: () => import("../views/Home.vue")
  // },
  // {
  //   path: "/about",
  //   name: "About",
  //   component: () => import("../views/About.vue")
  // },
  {
    path: "/404",
    component: () => import("../views/exception/404")
  }
];
